<style scoped lang="less">
.underline {
    // text-decoration: underline;
    border-bottom: 1px solid;
    padding-bottom: 2px;
    // text-decoration: none;
    // box-shadow: 0 10px;
}
.bold {
    font-weight: normal;
}
.indent {
    text-indent: 32px;
    text-align: justify;
}
.pre {
    background: white;
    color: black;
    width: 700px;
    height: 1131px;
    margin: 0 auto;
    position: relative;
}
.header {
    width: 100%;
    margin-bottom: 10px;
    .title {
        margin-top: 20px;
        text-align: center;
        font-size: 24px;
        cursor: pointer;
    }
    .detail {
        margin-top: 20px;
        font-size: 18px;
        width: 100%;
        display: flex;
        justify-content: flex-end;
    }
}
.container {
    line-height: 35px;
    margin-top: 30px;
    width: 100%;
    font-size: 16px;
}
.gaizhang {
    margin-top: 60px;
    width: 100%;
    .item {
        width: 100%;
        display: flex;
        > div {
            flex: 1;
        }
    }
}
.shenheyijian {
    margin-top: 70px;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}
.footer {
    margin-top: 60px;
    width: 100%;
    font-size: 12px;
    color: #666;
    line-height: 24px;
}
</style>

<template>
    <div class="yb-container">
        <div class="pre" id="pre">
            <div class="header">
                <div class="title bold" @click.stop="printOut">货权转移申请书</div>
                <div class="detail bold">
                    <div>编号：<span class="underline">&nbsp;&nbsp;&nbsp;{{forward.orderNO}}&nbsp;&nbsp;&nbsp;</span></div>
                </div>
            </div>

            <div class="container">
                <div class="bold">{{forward.house}}：</div>
                <div class="bold indent">兹申请我司（转出方）
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser1}}&nbsp;&nbsp;&nbsp;</span>将储存于贵司
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.tank}}&nbsp;&nbsp;&nbsp;</span>储罐的货物
                    <span class="underline">&nbsp;&nbsp;&nbsp;甲醇（进口）&nbsp;&nbsp;&nbsp;</span>数量：
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.count}}&nbsp;吨&nbsp;&nbsp;&nbsp;</span>（大写：
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{DX(forward.count)}}吨&nbsp;&nbsp;&nbsp;</span>）的货权，转移给（转入方）
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>。
                </div>
                <div class="bold indent">货权转移后，所发生的一切费用从
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.downDate}}&nbsp;&nbsp;&nbsp;</span>起由
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>承担，货物损耗从
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.downDate}}&nbsp;&nbsp;&nbsp;</span>起由
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.purchaser2}}&nbsp;&nbsp;&nbsp;</span>承担。
                </div>
                <div class="indent">包括但不限于费用、损耗、货转等各方权利义务，以本货权转移申请书及《太仓阳鸿石化货转仓储服务基本条款》执行。</div>
                <div class="indent"><span class="bold">费用标准：</span>仓储服务费按上一租期结束时剩余的货物数量计收
                    <span class="underline">&nbsp;&nbsp;&nbsp;{{forward.price}}&nbsp;&nbsp;&nbsp;</span>元/吨/天。从2020年6月10日起仓储服务费按上一个租期结束时剩余货物数量计收
                    <span class="underline">&nbsp;&nbsp;&nbsp;3&nbsp;&nbsp;&nbsp;</span>元/吨/天。具体收费以太仓阳鸿石化有限公司通知为准。
                </div>
                <div class="indent"><span class="bold">损耗标准：</span>从入库之日起
                    <span class="underline">&nbsp;&nbsp;&nbsp;90&nbsp;&nbsp;&nbsp;</span>天租期内储存正常损耗按货物入库数量的
                    <span class="underline">&nbsp;&nbsp;&nbsp;2&nbsp;&nbsp;&nbsp;</span>‰计算；超出
                    <span class="underline">&nbsp;&nbsp;&nbsp;90&nbsp;&nbsp;&nbsp;</span>天租期后，以
                    <span class="underline">&nbsp;&nbsp;&nbsp;30&nbsp;&nbsp;&nbsp;</span>天为一周期，按上一租期结束时剩余货物数量的
                    <span class="underline">&nbsp;&nbsp;&nbsp;1&nbsp;&nbsp;&nbsp;</span>‰计算。
                </div>
                <div class="indent"><span class="bold">办理手续：</span>转出方和转入方同意先以转出方正本扫描件（转出方的指定邮箱
                    <span class="underline">&nbsp;&nbsp;&nbsp;liuying.xie@shgroup.cn&nbsp;&nbsp;&nbsp;</span>）配套双方盖章的传真件办理货权转移手续；双方签章、签字必须清晰且已备案。通过扫描件配套传真件办理本货权转移，而产生的一切损失均由转出方和转入方自行承担，与贵司无关。本货权转移申请书自太仓阳鸿石化有限公司确认后生效，不可撤销。
                </div>
                <div class="bold indent">敬请贵司同意办理有关手续为盼！</div>

                <div class="gaizhang bold indent">
                    <div class="item">
                        <div>转出方公司盖章</div>
                        <div>转入方公司盖章</div>
                    </div>
                    <div class="item">
                        <div>授权代表签字：</div>
                        <div>授权代表签字：</div>
                    </div>
                    <div class="item">
                        <div>日期：</div>
                        <div>日期：</div>
                    </div>
                </div>

                <div class="shenheyijian bold" v-show="false">
                    <div>{{forward.house}}审核意见：（仓库确认后方可发货）</div>
                    <div>日期：</div>
                </div>

                <div class="footer">注：{{forward.house}}指定联系人：
                    <span class="underline">&nbsp;&nbsp;&nbsp;陆洁&nbsp;&nbsp;&nbsp;</span>；联系电话
                    <span class="underline">&nbsp;&nbsp;&nbsp;0512-53370165&nbsp;&nbsp;&nbsp;</span>；传真
                    <span class="underline">&nbsp;&nbsp;&nbsp;0512-53370155&nbsp;&nbsp;&nbsp;</span>；指定邮箱
                    <span class="underline">&nbsp;&nbsp;&nbsp;tcyhkf@grgroup.cc&nbsp;&nbsp;&nbsp;</span>；邮寄地址：
                    <span class="underline">&nbsp;&nbsp;&nbsp;江苏省苏州太仓市浮桥镇浏家港石化路1号&nbsp;&nbsp;&nbsp;</span>。
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HttpClient } from "../util/http";
import { actionConfirm, msgSuccess } from "../util/toast";
import dayjs from "dayjs";

export default {
    data() {
        return {
            forward: null
        };
    },
    computed: {},
    components: {},
    created() {
        this.forward = {
            orderNO: this.$route.query.orderNO,
            tank: decodeURIComponent(this.$route.query.tank),
            house: this.$route.query.house,
            price: this.$route.query.price,
            purchaser1: this.$route.query.purchaser1,
            purchaser2: this.$route.query.purchaser2,
            count: this.$route.query.count,
            date: dayjs(this.$route.query.date).format("YYYY年MM月DD日"),
            downDate: dayjs(this.$route.query.downDate).format("YYYY年MM月DD日")
        };
    },
    methods: {
        printOut() {
            window.print();
            // pdfUtils.outPdf(
            //     document.getElementById("pre"),
            //     this.forward.orderNO
            // );
        },
        DX(n) {
            // n = parseInt(n);
            // if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) return "数据非法";
            // var unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元角分",
            //     str = "";
            // n += "00";
            // var p = n.indexOf(".");
            // if (p >= 0) n = n.substring(0, p) + n.substr(p + 1, 2);
            // unit = unit.substr(unit.length - n.length);
            // for (var i = 0; i < n.length; i++)
            //     str +=
            //         "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
            // return str
            //     .replace(/零(仟|佰|拾|角)/g, "零")
            //     .replace(/(零)+/g, "零")
            //     .replace(/零(兆|万|亿|元)/g, "$1")
            //     .replace(/(兆|亿)万/g, "$1")
            //     .replace(/(京|兆)亿/g, "$1")
            //     .replace(/(京)兆/g, "$1")
            //     .replace(/(京|兆|亿|仟|佰|拾)(万?)(.)仟/g, "$1$2零$3仟")
            //     .replace(/^元零?|零分/g, "")
            //     .replace(/(元|角)$/g, "");
            var str = "";
            var unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾元";
            var p = n.indexOf(".");
            if (p >= 0) {
                unit = "京亿万仟佰拾兆万仟佰拾亿仟佰拾万仟佰拾点角分厘";
                n += "000";
                n = n.substr(0, p) + n.substr(p + 1, 3);
            }
            unit = unit.substr(unit.length - n.length);
            for (var i = 0; i < n.length; i++)
                str +=
                    "零壹贰叁肆伍陆柒捌玖".charAt(n.charAt(i)) + unit.charAt(i);
            return str
                .replace(/零(仟|佰|拾|角)/g, "零")
                .replace(/(零)+/g, "零")
                .replace(/零(兆|万|亿|元)/g, "$1")
                .replace(/(兆|亿)万/g, "$1")
                .replace(/(京|兆)亿/g, "$1")
                .replace(/(京)兆/g, "$1")
                .replace("元", "")
                .replace("角", "")
                .replace("分", "")
                .replace("厘", "");
        }
    }
};
</script>


        